import Kicker from './Kicker';
import SectionShell from './SectionShell';
import { asset } from './asset';
import { useTranslation } from 'react-i18next';

function IntroductionSection() {
  const { t } = useTranslation();
  const aboutImage = t('intro.about_image') === 'about-us-urdu.png' ? 'about-us-urdu.png' : 'about-us.png';
  return (
    <SectionShell id="about">
      <div className="grid gap-12 lg:items-start">
        <div className="grid gap-5">
          <div className="overflow-hidden rounded border border-slate-200 bg-white">
            <img src={asset(aboutImage)} alt={t('intro.about_image_alt')} className="h-full w-full object-cover" />
          </div>
        </div>
      </div>
      <div className="mt-10">
         <p className="text-sm font-semibold ">{t('intro.footer')}</p>
      </div>
    </SectionShell>
  );
}

export default IntroductionSection;
